var { Platform } = require('react-native');

if (Platform.OS === 'web') {
  module.exports = {
    Answers: {
      logPurchase: () => {},
      logCustom: () => {},
      logLogin: () => {},
      logContentView: () => {},
      logSignUp: () => {},
    },

    Crashlytics: {
    	recordError: (error) => {},
    	logException: (error) => {},
    }
  }
}
